export default "__VITE_ASSET__UlUhqTC3__"